import { create } from 'zustand'
import { UserActions, UserState } from './types'
import { devtools, persist } from 'zustand/middleware'

const initialState: UserState = {
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  avatarUrl: null,
  role: null,
  organizationId: null,
  sites: null,
  mobilePhone: null,
  landlinePhone: null,
  jobTitle: null,
}

export const useUserStore = create<UserState & UserActions>()(
  persist(
    devtools((set) => ({
      ...initialState,

      setUser: (user) => {
        set(user)
      },
      reset: () => {
        set(initialState)
      },
    })),
    {
      name: 'UserStore',
    }
  )
)
